'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    year: '',
    month: '',
    day: '',
    hour: '',
    minute: '',
    am: 'AM',
    pm: 'PM'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-date-picker/lib/locale/en_US.js
// module id = 934
// module chunks = 0